import { useFormContext } from 'react-hook-form';

export const useLinkedField = (linkedField = {}) => {
  const { enableWatchingLinkedField, fieldName } = linkedField;
  const { watch, resetField, trigger } = useFormContext();
  const resetFieldToDefault = () => {
    resetField(fieldName);
    trigger(fieldName);
  };
  const currentValue = enableWatchingLinkedField ? watch(fieldName) : '';

  return {
    currentValue,
    resetField: resetFieldToDefault
  };
};
